module.exports = __webpack_public_path__ + "img/search.e090026f.svg";